import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import powerAgents from './powerAgents.json';
import powerTools from './powerTools.json';
import powerData from './powerData.json';
import outbounds from './outbounds.json';
import workforce from './workforce.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import filterBar from './filterBar.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import kanban from './kanban.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import customRolesMgmt from './customRolesMgmt.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import osHome from './osHome.json';
import yearInReview from './yearInReview.json';
// Os textos da conversa de teste, os mesmos da página do link (L-24).
import conversaDeTeste from 'shared/components/conversaDeTeste/i18n/en.json';

export default {
  ...osHome,
  ...advancedFilters,
  ...agentBots,
  ...powerAgents,
  ...powerTools,
  ...powerData,
  ...outbounds,
  ...workforce,
  ...agentMgmt,
  ...attributesMgmt,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...datePicker,
  ...emoji,
  ...filterBar,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...kanban,
  ...integrationApps,
  ...integrations,
  ...customRolesMgmt,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...yearInReview,
  ...conversaDeTeste,
};
